<template>
  <v-app id="register">
    <header-simple />

    <v-content>
      <v-container class="grid-list-md">
        <v-layout layout row wrap>
          <v-flex xs12 md4 class="mt-5">
            <h2 class="mb-3 font-weight-light display-1 teal--text text-xs-center">Rejestracja</h2>
            <p
              class="headline font-weight-light text-xs-center"
            >Możesz założyć konto w Systemie Karta Mieszkańca, jeśli spełniasz jeden z&nbsp;poniższych wymogów:</p>
            <ul class="subheading">
              <li>Jesteś na stałe zameldowany w&nbsp;Mieście</li>
              <li>Rozliczasz się z podatku dochodowego w&nbsp;Mieście</li>
              <li>Opłacasz w&nbsp;Mieście podatek od nieruchomości</li>
              <li>Opłacasz media związane z nieruchomościami zlokalizowanymi w&nbsp;Mieście</li>
            </ul>
          </v-flex>

          <v-flex xs12 md8 class="mt-5">
            <v-form v-model="valid" lazy-validation>
              <v-container class="grid-list-md">
                <v-layout layout row wrap>
                  <v-flex xs12>
                    <v-card class="elevation-0 mb-3">
                      <v-toolbar class="elevation-0">
                        <v-toolbar-title class="font-weight-light primary--text">Dane logowania</v-toolbar-title>
                      </v-toolbar>

                      <v-card-text>
                        <w-schema :model="$schema.login">
                          <v-text-field prepend-icon="person" name="login" label="E-mail"></v-text-field>
                        </w-schema>

                        <p class="ml-4 pt-3 subheading grey--text darken-1">
                          <v-icon class="mr-2 lighten-2">error_outline</v-icon>Nie musisz podawać hasła - ustawisz je bezpiecznie po potwierdzeniu konta
                        </p>
                      </v-card-text>
                    </v-card>

                    <profile-form :$schema="$schema" />

                    <consents-input :model="$schema.termIds" :termsList="termsList" />

                    <v-card class="elevation-0 mb-3">
                      <v-card-actions class="text-xs-right pb-4">
                        <v-spacer></v-spacer>

                        <v-btn
                          depressed
                          large
                          light
                          round
                          color="danger"
                          :to="{name:'login'}"
                        >Powrót</v-btn>

                        <v-btn
                          depressed
                          large
                          dark
                          round
                          color="primary"
                          :disabled="!valid"
                          @click="tryRegister"
                        >Zarejestruj się</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

    <material-dialog
      title="Twoje konto zostało zarejestrowane"
      text="Kliknij w link wysłany w wiadomości e-mail, żeby je potwierdzić."
      confirmText="Ok"
      :show="showDialog"
      :showCancel="false"
      :width="500"
      @confirm="redirectToLogin"
    />
  </v-app>
</template>

<script>
import { mapState } from 'vuex';
import { WSchema, schemaMixin } from '@witkac/vuetify-components';
import { profileResource } from '@witkac/kartamiejska-resources';
import { ProfileType } from '@witkac/kartamiejska-shared';

import schema from '@/schemas/register.schema';
import ConsentsInput from '@/components/forms/ConsentsInput';
import ProfileForm from '@/components/forms/ProfileForm';
import HeaderSimple from '@/components/layout/HeaderSimple';
import MaterialDialog from '@/components/material/Dialog';
import store from '@/store/store';

// @vuese
// Formularz rejestracji użytkownika
// @group Auth
export default {
  mixins: [schemaMixin],
  components: {
    WSchema,
    HeaderSimple,
    ConsentsInput,
    ProfileForm,
    MaterialDialog
  },
  data() {
    return {
      valid: true,
      showPassword: false,
      showDialog: false,
      stepper: {
        step: 1
      },
      model: { profile: {} }
    };
  },
  schema,
  methods: {
    // @vuese
    // Rejestruje użytkownika, jeżeli wszystkie dane są prawidłowe
    async tryRegister() {
      const errors = this.$schema.$validateAll();
      this.valid = !errors.length;
      if (this.valid) {
        profileResource.add(this.$schema.$model).then(
          success => (this.showDialog = true),
          error =>
            this.$store.dispatch('notifyError', {
              title: 'Nie udało się zarejestrować konta.'
            })
        );
      }
    },

    // @vuese
    // Przekierowuje na ekran logowania
    redirectToLogin() {
      this.$router.push({ name: 'login' });
    }
  },
  computed: mapState({ termsList: state => state.terms.current }),
  beforeRouteEnter(to, from, next) {
    store.dispatch('terms/getCurrent', ProfileType.CLIENT).then(() => next());
  },
  beforeCreate() {
    this.$options.external = {
      requiredTerms: this.$store.state.terms.current
        .filter(terms => terms.required)
        .map(terms => terms.id)
    };
  }
};
</script>
<style>
.theme--dark.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
  background-color: hsla(0, 0%, 0%, 0.2) !important;
  color: white !important;
}

.not-required .error--text {
  color: inherit !important;
  caret-color: inherit !important;
}

.not-required .v-messages__message {
  display: none;
}
</style>